import React from 'react';
import styles from './Campaign.module.scss';

interface CampaignProps {
  title?: string;
  subtitle?: string;
}

export const Campaign: React.FC<CampaignProps> = ({ title, subtitle }) => {
  if (!title) return null;
  return (
    <div className={styles.campaignWrapper}>
      <h2 className={styles.campaignTitle}>{title}</h2>
      {subtitle ? <p className={styles.campaignSubTitle}>{subtitle}</p> : null}
    </div>
  );
};